// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.ordersearch', {
        url: '/search/{orderId}',
        templateUrl: 'main/order/ordersearch/ordersearch.tpl.html',
        controller: 'MainOrderSearchController as vm',
        params: {
            useScannerNavigation: false,
            searchTerm: '',
            showOnlyUndeliveredOrders: true,
            orderTypes: ['Store']
        }
    });
}

// @ngInject
function MainOrderSearchController($rootScope, DS, $state, $stateParams, OrdersApiService, Rms2OrdersApiService, loadSpinnerService, AuthService) {
    var vm = this;
    vm.canAccess = AuthService.canAccess;

    //Properties
    vm.orderId = ($stateParams.orderId) ? $stateParams.orderId : undefined;
    vm.orderTypes = ($stateParams.orderTypes) ? $stateParams.orderTypes : ['Store'];
    vm.searchTerm =  ($stateParams.searchTerm) ? $stateParams.searchTerm : "";
    vm.useScannerNavigation = $stateParams.useScannerNavigation;
    vm.selectedOrder = {};
    vm.orders = [];
    vm.currentPage = 1;
    vm.totalItems = 0;
    vm.limit = 15;
    vm.showBackButton = false;
    vm.showSearchFields = true;
    var showUndeliveredOnlyInit = true;
    var showUnprintedOnlyInit = false;
    var showUnapprovedOnlyInit = false;
    var onlyOrderNumber = false;
    vm.monthsBack = null;
    vm.showUndeliveredOnly = ($stateParams.showOnlyUndeliveredOrders !== undefined) ? $stateParams.showOnlyUndeliveredOrders : showUndeliveredOnlyInit;
    vm.showUnprintedOnly = showUnprintedOnlyInit;
    vm.showUnapprovedOnly = showUnapprovedOnlyInit;
    vm.onlyOrderNumber = onlyOrderNumber;
    vm.printModeType = 'none';
    vm.isLoading = false;

    //Methods
    vm.loadOrders = loadOrders;
    vm.selectOrder = selectOrder;
    vm.toggleSearchFields = toggleSearchFields;
    vm.searchTermChanged = searchTermChanged;

    activate();

    function activate() {
        if (vm.orderId) {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.getById(vm.orderId).then(function(response) {
                vm.order = response.data.order;
                vm.links = response.data.links;
                vm.showSearchFields = false;
            }).finally(function afterGetAllOrders() {
                loadSpinnerService.stop('mainSpinner', {force: true});
            });
        } else {
            vm.showSearchFields = true;
            loadOrders();
        }

    }

    function searchTermChanged(searchTerms) {
        if(vm.isLoading) return;
        vm.isLoading = true;

        if (searchTerms) {
            if (searchTerms.currentPage && vm.currentPage !== searchTerms.currentPage) { vm.currentPage = searchTerms.currentPage; }
            if (searchTerms.searchTerm && vm.searchTerm !== searchTerms.searchTerm) { vm.searchTerm = searchTerms.searchTerm; }
            if (searchTerms.limit && vm.limit !== searchTerms.limit) { vm.limit = searchTerms.limit; }
            if (searchTerms.orderTypes && vm.orderTypes !== searchTerms.orderTypes) { vm.orderTypes = searchTerms.orderTypes; }
            vm.showUndeliveredOnly = searchTerms.showUndeliveredOnly;
            vm.showUnprintedOnly = searchTerms.showUnprintedOnly;
            vm.showUnapprovedOnly = searchTerms.showUnapprovedOnly;
            console.log(searchTerms.onlyOrderNumber);
            vm.onlyOrderNumber = searchTerms.onlyOrderNumber;
            vm.monthsBack = searchTerms.monthsBack;

            loadOrders();
        }
    }

    function selectOrder(orderId) {
        $state.go('order.ordersearch', {
            orderId: orderId,
            searchTerm: vm.searchTerm,
            useScannerNavigation: vm.useScannerNavigation,
            showOnlyUndeliveredOrders: vm.showUndeliveredOnly,
            orderTypes: vm.orderTypes
        });
    }

    function loadOrders() {
        loadSpinnerService.start('mainSpinner');
        var searchTerms = {
            page: vm.currentPage,
            searchTerm: vm.searchTerm,
            limit: vm.limit,
            orderTypes: vm.orderTypes,
            onlyOrderNumber: vm.onlyOrderNumber,
            monthBack: vm.monthsBack,
            showUndeliveredOnly: vm.showUndeliveredOnly,
            showUnprintedOnly: vm.showUnprintedOnly,
            showUnapprovedOnly: vm.showUnapprovedOnly
        };
        var tenantStringIdentifier = $rootScope.currentUser.tenant.tenantStringIdentifier.toLowerCase();
        console.log(tenantStringIdentifier);

        if (isElasticSearchEnabledTenant(tenantStringIdentifier)) {
            Rms2OrdersApiService.getAll(searchTerms).then(function(response) {
                vm.orders = response.results;

                _.forEach(vm.orders, function (o) {
                    o.isSelected = false;
                });

                vm.totalItems = response.total;
                vm.currentPage = response.page;
                vm.searchTerm = vm.searchTerm ? vm.searchTerm : '';
                formatPlannedDeliveryDate(vm.orders);
            }, function(error) {
                console.log(error);
                vm.isLoading = false;
            }).finally(function afterGetAllOrders() {
                loadSpinnerService.stop('mainSpinner', {force: true});
                vm.isLoading = false;
            });
        } else {
            OrdersApiService.getAll(searchTerms).then(function(response) {
                vm.orders = response.results;

                _.forEach(vm.orders, function (o) {
                    o.isSelected = false;
                });

                vm.totalItems = response.total;
                vm.currentPage = response.page;
                vm.searchTerm = vm.searchTerm ? vm.searchTerm : '';
                formatPlannedDeliveryDate(vm.orders);
            }, function(error) {
                console.log(error);
                vm.isLoading = false;                
            }).finally(function afterGetAllOrders() {
                loadSpinnerService.stop('mainSpinner', {force: true});
                vm.isLoading = false;
            });
        }
    }

    function isElasticSearchEnabledTenant(tenantStringIdentifier) {
            return (tenantStringIdentifier != "pondus" && DS.defaults.ENV.NAME !== 'local')
    }

    // Formats the delivery dates to YYYY-MM-DD instead of YYYY-MM-DDTHH:MM:SS
    function formatPlannedDeliveryDate(orders) {
        for (var i = 0; i < orders.length; i++) {
            var order = orders[i];
            order.plannedDeliveryDate = order.plannedDeliveryDate.split('T')[0];
        }
    }

    function toggleSearchFields() {
        if (!vm.order || !vm.order.id) { return; }
        if (vm.showSearchFields === false && (!vm.orders || vm.orders.length === 0)) {
            loadOrders();
        }
        vm.showSearchFields = !vm.showSearchFields;
    }
}

angular
    .module('order.ordersearch', [])
    .config(stateConfig)
    .controller('MainOrderSearchController', MainOrderSearchController);
